import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: '¿Cuánto tiempo me va a llevar?',
  answer: 'Las técnicas toman entre 2 y 5 minutos. Podés hacerlas mientras hacés café o esperás un ascensor.'
}, {
  question: '¿Es un curso largo?',
  answer: 'No. Es un manual de acción directa. Vas al grano desde la página 1.'
}, {
  question: '¿Cómo recibo el material?',
  answer: 'De forma inmediata en tu email tras el pago. Es un producto digital, lo tenés en tu celular u ordenador en segundos.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-16 md:py-24 px-4" data-id="element-11">
      <div className="max-w-3xl mx-auto" data-id="element-12">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} data-id="element-13">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-main text-center mb-12" data-id="element-14">
            Preguntas Frecuentes
          </h2>

          <div className="space-y-4" data-id="element-15">
            {faqs.map((faq, index) => <div key={index} className="border border-white/10 rounded-xl overflow-hidden bg-card/30" data-id="element-16">
                <button onClick={() => toggle(index)} className="w-full flex items-center justify-between p-6 text-left hover:bg-white/5 transition-colors duration-200" data-id="element-17">
                  <span className="text-lg font-semibold text-main pr-4" data-id="element-18">
                    {faq.question}
                  </span>
                  <motion.div animate={{
                rotate: openIndex === index ? 180 : 0
              }} transition={{
                duration: 0.25
              }} className="shrink-0 text-warm" data-id="element-19">
                    <ChevronDownIcon size={20} data-id="element-20" />
                  </motion.div>
                </button>
                <AnimatePresence data-id="element-21">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-22">
                      <p className="px-6 pb-6 text-muted leading-relaxed" data-id="element-23">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}